// extracted by mini-css-extract-plugin
export default {"item":"ProvidersItemWrapper_item__nUvJV"};